export const company = {
    name: '贵州博众致远科技有限公司',
    address: '贵州省贵阳市观山湖区国际金融中心ONE号楼21楼21室',
    fixPhone: '0851-87973755',
    phone: '13912344321',
    putOnRecords: '黔公网备案 xxxxx1号',
    email: '3257079465@qq.com'
}